rdefine("ag/models/galleryModel",['backbone'],function(Backbone,template) {
    return Backbone.Ribs.Model.extend({
        defaults:{
            id:null,
            salt:null,
            title:'',
            description:'',
            order:0
        }
    });
});